import { ChevronLeft, ChevronRight } from "lucide-react";
import { dayKey, monthMatrix, monthLabel } from "@/lib/calendar";

const DOW = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

/** events: [{ id, at (Date|ISO), ...rest }]; renderEvent(ev) -> node. */
export const MonthGrid = ({ month, onMonth, events, renderEvent, testId = "month-grid", dark = false }) => {
  const byDay = events.reduce((m, ev) => {
    const k = dayKey(ev.at);
    (m[k] ||= []).push(ev);
    return m;
  }, {});
  const today = dayKey(new Date());
  const cells = monthMatrix(month);
  const line = dark ? "border-white/10" : "border-slate-200";
  const muted = dark ? "text-white/30" : "text-slate-300";
  const text = dark ? "text-white" : "text-[#0A192F]";

  return (
    <div data-testid={testId} className={`${text}`}>
      <div className="flex items-center justify-between mb-4">
        <button type="button" data-testid={`${testId}-prev`} onClick={() => onMonth(-1)} aria-label="Previous month" className={`p-2 border ${line} hover:border-[var(--accent)] transition-colors`}>
          <ChevronLeft className="w-4 h-4" />
        </button>
        <div className="font-display text-xl md:text-2xl tracking-tight" data-testid={`${testId}-label`}>{monthLabel(month)}</div>
        <button type="button" data-testid={`${testId}-next`} onClick={() => onMonth(1)} aria-label="Next month" className={`p-2 border ${line} hover:border-[var(--accent)] transition-colors`}>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
      <div className="grid grid-cols-7 text-[10px] uppercase tracking-widest text-slate-500 mb-1">
        {DOW.map((d) => <div key={d} className="px-2 py-1">{d}</div>)}
      </div>
      <div className={`grid grid-cols-7 border-t border-l ${line}`}>
        {cells.map((d) => {
          const k = dayKey(d);
          const inMonth = d.getMonth() === month.getMonth();
          const evs = byDay[k] || [];
          return (
            <div
              key={k}
              data-testid={evs.length ? `${testId}-day-${k}` : undefined}
              className={`min-h-[72px] md:min-h-[96px] border-r border-b ${line} p-1.5 md:p-2 ${inMonth ? "" : dark ? "bg-white/[0.03]" : "bg-slate-50/60"}`}
            >
              <div className={`text-xs font-mono ${inMonth ? (k === today ? "text-[var(--accent)] font-bold" : "") : muted}`}>{d.getDate()}</div>
              <div className="mt-1 space-y-1">{evs.map(renderEvent)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthGrid;
